import {
  Box,
  Grid,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useCallback, useEffect, useMemo, useState } from "react";
import Chart from "react-apexcharts";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../../components/CustomTextField";
import CustomSelect from "../../../../components/Select/Select";
import {
  createVitalsByAppointmentIdWoLoader,
  deleteVitalsByIdWoLoader,
  getCoreVitalsWoLoader,
  getVitalGroupsDetailsByIdWoLoader,
  getVitalTrendsByPetId,
} from "../../../../redux/reducers/clinicSlice";
import {
  getPetsCompliantSummaryWoLoader,
  updateWeightByPetAndApntId,
} from "../../../../redux/reducers/petSlice";
import { AppColors } from "../../../../util/AppColors";

const initValues = { group: null };
const addIcon = { color: AppColors.appPrimary, width: 15, height: 15 };
const vitalTrendTabs = ["Temperature", "Weight"];

const getVitalTrendFieldKey = (tab) => {
  return tab === "Weight" ? "Body Weight" : "Body Temperature";
};

const PetVitals = () => {
  const dispatch = useDispatch();
  const [createVsble, setCreateVsble] = useState(false);
  const [vitalValues, setVitalValues] = useState(initValues);
  const [selecetdItem, setSelectedItem] = useState(null);
  const [delModVsble, setDelModVsble] = useState(false);
  const [isGroupErr, setGroupErr] = useState(false);
  const [viewTreadsVsble, setViewTreadsVsble] = useState(false);
  const [selectedTab, setSelectedTab] = useState("Temperature");
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const {
    vitalGroups,
    vitalListById,
    selectedClinicBranch,
    coreVitals,
    vitalTrends,
  } = useSelector((state) => state?.clinic);
  const role = localStorage.getItem("role");

  useEffect(() => {
    dispatch(getCoreVitalsWoLoader());
  }, []);

  useEffect(() => {
    if (reqDet?.vitals?.length > 0) {
      setSelectedItem(reqDet?.vitals?.[0]);
      setVitalValues(reqDet?.vitals?.[0]?.data?.[0]);
    }
  }, [reqDet?.vitals]);

  const getSoretdVitals = () => {
    return [...(coreVitals ?? [])]?.sort((a, b) => b?.vitalId - a?.vitalId);
  };

  // useEffect(() => {
  //   // callApi();
  //   const url =
  //     role === "ROLE_DOCTOR" && selectedClinicBranch?.branchId
  //       ? `?clinicId=${selectedClinicBranch?.branchId}`
  //       : "";
  //   dispatch(getVitalGroupsWoLoader(url));
  // }, [role, selectedClinicBranch]);

  const callApi = () => {
    dispatch(
      getPetsCompliantSummaryWoLoader(reqDet?.appointment?.appointmentId),
    );
  };

  const getVitalGroupDetailsById = (grpId, obj) => {
    dispatch(getVitalGroupsDetailsByIdWoLoader(grpId)).then((res) => {
      if (res?.payload) {
        let reqObj = { ...obj };
        res?.payload?.forEach((det) => {
          reqObj = { ...reqObj, [det?.vitalName]: "" };
        });
        setVitalValues(reqObj);
      }
    });
  };

  const onChange = (name, value) => {
    if (name === "group") {
      setGroupErr(!value?.vitalGroupId ? true : false);
      if (value?.vitalGroupId)
        getVitalGroupDetailsById(value?.vitalGroupId, {
          ...vitalValues,
          [name]: value,
        });
    }
    setVitalValues({ ...vitalValues, [name]: value });
  };

  // const getVitalGroups = () => {
  //   return vitalGroups?.map((item) => ({
  //     name: item?.groupName,
  //     value: item?.groupName,
  //     vitalGroupId: item?.roomId,
  //   }));
  // };

  const handleSave = () => {
    // if (!vitalValues?.group?.vitalGroupId) return setGroupErr(true);
    let reqData = {
      //  remarks: vitalValues?.remarks
    };
    getSoretdVitals()?.forEach((li) => {
      reqData[li?.vitalName] = vitalValues?.[li?.vitalName];
    });
    const data = {
      vitalGroupId: 1, //vitalValues?.group?.vitalGroupId,
      vitalGroup: "Core Vitals", // vitalValues?.group?.value,
      data: [reqData],
    };
    if (selecetdItem) data.vitalId = selecetdItem?.vitalId;
    dispatch(
      createVitalsByAppointmentIdWoLoader({
        apntId: reqDet?.appointment?.appointmentId,
        data,
      }),
    ).then((res) => {
      if (res?.payload) {
        if (
          Number(reqDet?.appointment?.weight) !==
            Number(vitalValues?.["Body Weight"]) &&
          vitalValues?.["Body Weight"]?.length > 0
        ) {
          dispatch(
            updateWeightByPetAndApntId({
              url: `/${reqDet?.appointment?.appointmentId}/pet/${reqDet?.appointment?.petId}/weight?weight=${vitalValues?.["Body Weight"]}`,
            }),
          ).then((res2) => {
            if (res2?.payload) callApi();
          });
        } else {
          callApi();
        }
        setCreateVsble(false);
        setVitalValues(initValues);
        setSelectedItem(null);
        setGroupErr(false);
      }
    });
  };

  const onEdit = (dta) => {
    // if (reqDet?.appointment?.appointmentStatus?.toLowerCase() !== "completed") {
    //   return;
    // }
    setSelectedItem(dta);
    const reqObj = {
      group: {
        name: dta?.vitalGroup,
        value: dta?.vitalGroup,
        vitalGroupId: dta?.vitalGroupId,
      },
    };
    Object.keys(dta?.data?.[0])?.forEach(function (key, index) {
      reqObj[key] = dta?.data?.[0]?.[key];
    });
    setVitalValues(reqObj);
    setCreateVsble(true);
  };

  const handleDelete = (pv) => {
    setSelectedItem(pv);
    setDelModVsble(true);
  };

  const onCloseDelMod = () => {
    setDelModVsble(false);
    setSelectedItem(null);
  };

  const onCofirmDelete = () => {
    if (!selecetdItem?.vitalId) return;
    dispatch(deleteVitalsByIdWoLoader(selecetdItem?.vitalId)).then((res) => {
      if (res?.payload) {
        onCloseDelMod();
        callApi();
      }
    });
  };

  const vitalTrendChartData = useMemo(() => {
    const vitalFieldKey = getVitalTrendFieldKey(selectedTab);

    return (vitalTrends ?? [])
      .map((item) => {
        const record = item?.data?.[0];
        if (!record) return null;

        const rawValue = record?.[vitalFieldKey];
        if (rawValue === undefined || rawValue === null || rawValue === "") {
          return null;
        }

        const value = Number(rawValue);
        if (Number.isNaN(value)) return null;

        return {
          vitalId: item?.vitalId,
          value,
          label: moment(item?.createdDate).format("DD MMM YYYY"),
          dateTime: moment(item?.createdDate).format("DD MMM YYYY, HH:mm"),
          createdDate: item?.createdDate,
        };
      })
      .filter(Boolean)
      .sort(
        (a, b) =>
          new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime(),
      );
  }, [vitalTrends, selectedTab]);

  const vitalTrendTooltipFormatter = useCallback(
    ({ dataPointIndex }) => {
      const item = vitalTrendChartData?.[dataPointIndex];
      if (!item) return "";

      const unit = selectedTab === "Weight" ? "Kg" : "°F";

      return (
        '<div class="apexcharts-tooltip-title" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; background-color: #EBEBEB; color: #000; padding: 8px; margin: 0;">' +
        item.dateTime +
        '<span class="apexcharts-tooltip-marker" style="background-color: #0047AB; margin-left: 5px; width: 12px; height: 12px; border-radius: 2px; display: inline-block;"></span>' +
        "</div>" +
        '<div class="apexcharts-tooltip-series-group" style="order: 1; display: flex; background-color: #fff; padding: 8px;">' +
        '<div class="apexcharts-tooltip-text" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #000;">' +
        '<div class="apexcharts-tooltip-y-group">' +
        '<span class="apexcharts-tooltip-text-y-label">' +
        selectedTab +
        ": </span>" +
        '<span class="apexcharts-tooltip-text-y-value" style="font-weight: 600;">' +
        item.value +
        " " +
        unit +
        "</span>" +
        "</div>" +
        "</div>" +
        "</div>"
      );
    },
    [vitalTrendChartData, selectedTab],
  );

  const vitalTrendChartOptions = useMemo(
    () => ({
      chart: { type: "line", toolbar: { show: false }, fontFamily: "inherit" },
      stroke: {
        width: 2,
        curve: "smooth",
      },
      markers: {
        size: 4,
        colors: ["#fff"],
        strokeColors: "#0047AB",
        strokeWidth: 2,
      },
      dataLabels: { enabled: false },
      xaxis: {
        categories: vitalTrendChartData.map((item) => item.dateTime),
        title: {
          text: "Date / Time",
          style: { fontSize: "12px", color: "#666", fontWeight: 500 },
        },
        labels: {
          style: { fontSize: "11px", colors: "#2C2C49", fontWeight: 500 },
          rotate: -35,
          hideOverlappingLabels: true,
        },
        axisBorder: { show: false },
        axisTicks: { show: false },
      },
      yaxis: {
        labels: {
          style: { fontSize: "12px", colors: "#2C2C49" },
          formatter: (val) => val,
        },
        title: {
          text: selectedTab === "Weight" ? "Kg" : "°F",
          style: { fontSize: "12px", color: "#666", fontWeight: 500 },
        },
      },
      grid: {
        strokeDashArray: 4,
        borderColor: "#E9ECEF",
      },
      colors: ["#0047AB"],
      tooltip: {
        custom: vitalTrendTooltipFormatter,
      },
    }),
    [vitalTrendChartData, selectedTab, vitalTrendTooltipFormatter],
  );

  const vitalTrendChartSeries = useMemo(
    () => [
      {
        name: selectedTab,
        data: vitalTrendChartData.map((item) => item.value),
      },
    ],
    [vitalTrendChartData, selectedTab],
  );

  const onViewTrends = () => {
    dispatch(getVitalTrendsByPetId(reqDet?.appointment?.petId));
    setViewTreadsVsble(true);
  };

  return (
    <>
      <div className="ph20 mt10">
        {/* {!createVsble && (
          <div>
            <div className="flex-row-ali-cen mh20">
              <div className="w65Per">
                <Typography className="font-bold blue-color fs12">
                  Name
                </Typography>
              </div>
              <div className="w25Per">
                <Typography className="font-bold blue-color fs12">
                  Recorded Date/Time
                </Typography>
              </div>
              <div className="w5Per" />
            </div>
            <div className="blue-hor-split mt5" />
            {reqDet?.vitals?.map((pv) => (
              <div className="flex-row-ali-cen mh20 mt10" key={pv?.vitalId}>
                <div className="w65Per" onClick={() => onEdit(pv)}>
                  <Custom3dotString
                    str={pv?.vitalGroup}
                    className="txt-semi-bold blue-color fs12 underline cursor"
                  />
                </div>
                <div className="w25Per">
                  <Typography className="font-medium gray34 fs12">
                    {moment(new Date(pv?.updatedDate)).format(
                      "DD MMM YYYY, HH:mm",
                    )}
                  </Typography>
                </div>
                <div className="w5Per">
                  <div className="cursor" onClick={() => handleDelete(pv)}>
                    <div className="flex-center">
                      <DeleteOutlineIcon sx={delBtn} />
                    </div>
                    <Typography className="red3 fs8 txt-semi-bold text-align-center">
                      Delete
                    </Typography>
                  </div>
                </div>
              </div>
            ))}
            {reqDet?.appointment?.appointmentStatus?.toLowerCase() !==
            "completed" ? (
              <div
                className="flex-row-ali-cen mt20 cursor"
                onClick={() => setCreateVsble(true)}
              >
                <div className="flex-center plus-icon">
                  <AddIcon sx={addIcon} />
                </div>
                <Typography className="blue-color fs16 ml5 font-bold">
                  Add
                </Typography>
              </div>
            ) : null}
          </div>
        )} */}
        {/* {createVsble && ( */}
        <Grid container spacing={2} className="ph10">
          {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row">
                <Typography className="blue-color fs14 txt-semi-bold mt5">
                  Vital Group :
                </Typography>
                <div className="w70Per ml20">
                  <CustomSelect
                    list={getVitalGroups()}
                    value={vitalValues?.group}
                    handleChange={(e, value) => onChange("group", value)}
                    search
                    error={isGroupErr}
                    helperText={isGroupErr ? "This field is required" : ""}
                  />
                </div>
              </div>
            </Grid> */}

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="flex-row-between-align-center">
              {selecetdItem ? (
                <Typography className="gray35 fs14 txt-semi-bold">
                  Last Recorded:{" "}
                  {moment(new Date(selecetdItem?.updatedDate)).format(
                    "DD MMM YYYY, HH:mm",
                  )}
                </Typography>
              ) : null}
              <div className="flex1-end">
                <Typography
                  className="blue-color fs14 txt-semi-bold underline cursor"
                  onClick={onViewTrends}
                >
                  View Trends
                </Typography>
              </div>
            </div>
          </Grid>

          {getSoretdVitals()?.map((li) => {
            const isDrop =
              li?.inputType === "DropDown" || li?.inputType === "Drop Down";
            const dropList = isDrop
              ? li?.dropdown?.map((dl) => ({ name: dl, value: dl }))
              : [];
            return (
              <Grid item xs={6} sm={6} md={6} lg={6} xl={6} key={li?.vitalId}>
                <Typography className="font-bold fs14 gray34">
                  {li?.vitalName ?? ""}
                </Typography>
                <div className="flex-row mb5">
                  <Typography className="fs14 gray34 txt-regular">
                    {li?.unit}
                  </Typography>
                </div>
                {isDrop ? (
                  <CustomSelect
                    list={dropList}
                    value={vitalValues?.[li?.vitalName]}
                    handleChange={(e) =>
                      onChange(li?.vitalName, e?.target?.value)
                    }
                    select
                  />
                ) : (
                  <CustomTextField
                    fullWidth
                    value={vitalValues?.[li?.vitalName]}
                    handleChange={(e) =>
                      onChange(li?.vitalName, e?.target?.value)
                    }
                  />
                )}
              </Grid>
            );
          })}
          {/* {vitalValues?.group?.vitalGroupId &&
            vitalListById?.map((li, i) => {
              const isDrop = li?.inputType === "DropDown";
              const dropList = isDrop
                ? li?.dropdown?.map((dl) => ({ name: dl, value: dl }))
                : [];

              return (
                <Grid item xs={6} sm={6} md={6} lg={6} xl={6} key={li?.vitalId}>
                  <Typography className="font-bold fs14 gray34">
                    {li?.vitalName ?? ""}
                  </Typography>
                  <div className="flex-row mb5">
                    <Typography className="fs14 gray34 txt-regular">
                      {li?.unit}
                    //    ({li?.lowerRange}
                    // {li?.upperRange?.length > 0 ? ` - ${li?.upperRange}` : ""})
                    </Typography>
              //        <div className="flex1-end pr10">
              //   <div className="green-dot" />
              // </div> 
                  </div>
                  {isDrop ? (
                    <CustomSelect
                      list={dropList}
                      value={vitalValues?.[li?.vitalName]}
                      handleChange={(e) =>
                        onChange(li?.vitalName, e?.target?.value)
                      }
                      select
                    />
                  ) : (
                    <CustomTextField
                      fullWidth
                      value={vitalValues?.[li?.vitalName]}
                      handleChange={(e) =>
                        onChange(li?.vitalName, e?.target?.value)
                      }
                      // suffix="°F"
                    />
                  )}
                </Grid>
              );
            })} */}
          {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="font-bold fs14 gray34 mb5">
                Remarks
              </Typography>
              <CustomTextField
                fullWidth
                value={vitalValues?.remarks}
                handleChange={(e) => onChange("remarks", e?.target?.value)}
                multiline
              />
            </Grid> */}
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="flex1-end mt20">
              <div>
                <CustomButton text="Save" smallBtn onClick={handleSave} />
              </div>
            </div>
          </Grid>
        </Grid>
        {/* )} */}
      </div>
      <CustomModal
        open={delModVsble}
        onClose={onCloseDelMod}
        header="Delete"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to delete the Vital?
        </Typography>

        <div className="clinic-mod-btn-pos mb10 mt15">
          <div className="mr10">
            <CustomButton text="Yes" redBtn onClick={onCofirmDelete} smallBtn />
          </div>
          <div className="ml10">
            <CustomButton text="No" onClick={onCloseDelMod} smallBtn />
          </div>
        </div>
      </CustomModal>
      <CustomModal
        open={viewTreadsVsble}
        onClose={() => setViewTreadsVsble(false)}
        header="Vital Trends"
        modal
        modalWidth={80}
      >
        <Box sx={{ px: 2.5, pb: 2.5 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
            flexWrap="wrap"
            gap={1.5}
          >
            <Typography
              variant="subtitle1"
              fontWeight={600}
              sx={{ color: "#2C2C49" }}
            >
              {selectedTab} Trend
            </Typography>
            <ToggleButtonGroup
              value={selectedTab}
              exclusive
              onChange={(_, val) => val && setSelectedTab(val)}
              size="small"
              sx={{
                backgroundColor: "#f0f2f5",
                borderRadius: "12px",
                "& .MuiToggleButtonGroup-grouped": {
                  borderRadius: "7px",
                  borderColor: "transparent",
                  color: "#333",
                  transition: "none",
                  textTransform: "none",
                  px: 2,
                  "&.Mui-selected": {
                    backgroundColor: "#005EB8",
                    color: "#fff",
                  },
                },
              }}
            >
              {vitalTrendTabs.map((tab) => (
                <ToggleButton key={tab} value={tab}>
                  {tab}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Box>
          <Box
            sx={{
              backgroundColor: "#FAFBFC",
              borderRadius: "8px",
              padding: "16px",
              border: "1px solid #E9ECEF",
              minHeight: 320,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {vitalTrendChartData?.length > 0 ? (
              <Box sx={{ width: "100%" }}>
                <Chart
                  key={selectedTab}
                  options={vitalTrendChartOptions}
                  series={vitalTrendChartSeries}
                  type="line"
                  height={350}
                />
              </Box>
            ) : (
              <Typography
                sx={{
                  color: "#636363",
                  fontSize: "14px",
                  fontWeight: 500,
                  fontFamily: "Montserrat",
                }}
              >
                No records available
              </Typography>
            )}
          </Box>
        </Box>
      </CustomModal>
    </>
  );
};

export default PetVitals;
